import { Paper, Typography } from 'material-ui';
import { withStyles } from 'material-ui/styles/index'; // only needs to be imported once
import React from 'react';
import { translate } from 'react-i18next';
import FlightComponent from './FlightComponent';
import { getAirports } from './flightServices';
import moment from 'moment';
import get from 'lodash.get';

const styles = theme => ({
    clientRowTitle: {
        fontSize: '14px',
        fontWeight: 600,
        paddingLeft: '20px !important',
    },
    clientRowValue: {
        fontSize: '14px',
        fontWeight: 300,
        paddingLeft: '20px'
    },
    expandIcon: {
        color: theme.palette.primary.main
    },
    bookingTitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 20px 25px',
        fontWeight: 'bold',
        fontSize: '1.2rem',
        borderLeft: '2px solid ' + theme.palette.primary.main
    },
    bookingSubtitle: {
        color: theme.palette.primary.main,
        padding: '20px 0 5px 25px',
        fontWeight: 'normal',
        fontSize: '1rem'
    },
    paperFrame: {
        margin: '40px 0px'
    }
});


class ReservationFlightRender extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            airports: [],
            outboundFlight: this.props.reservation.flights[0],
            returnFlight: this.props.reservation.flights[1],
            minArrivalDate: this.getStartOfDay(get(this.props, 'reservation.flights[0].arrivalDate', new Date()))
        };
        this.handleArrivalDate = this.handleArrivalDate.bind(this);
    }

    async componentDidMount() {
        const airportsData = await getAirports();
        if (airportsData) {
            this.setState({
                airports: airportsData
            });
        }
    }

    handleArrivalDate(data) {
        this.setState({
            minArrivalDate: this.getStartOfDay(data)
        });
    }

    getStartOfDay(date) {
        return moment(date).startOf('day').toDate();
    }

    render() {
        const { classes, t } = this.props;
    
        return (
            <Paper className={classes.paperFrame} id="flightdetail">
                <Typography className={classes.bookingTitle}>
                    {t('BOOKING_DETAIL.FLIGHT_DETAIL')}
                </Typography>
                <Typography className={classes.bookingSubtitle}>
                    <strong>
                    {t('BOOKING_DETAIL.OUTBOUND_FLIGHT')}
                    </strong>
                </Typography>
                <FlightComponent
                    flight={this.state.outboundFlight}
                    airports={this.state.airports}
                    onChange={this.props.setOutboundFlight}
                    onArrivalChange={this.handleArrivalDate}
                    showButtons={this.props.showButtons}
                    reservationId={this.props.reservation.olympiaLocator}
                    minPossibleDeparture={moment().startOf('day').toDate()}
                />
                <Typography className={classes.bookingSubtitle}>
                    <strong>
                    {t('BOOKING_DETAIL.RETURN_FLIGHT')}
                    </strong>
                </Typography>
                <FlightComponent
                    flight={this.state.returnFlight}
                    airports={this.state.airports}
                    onChange={this.props.setReturnFlight}
                    onArrivalChange={() => {}}
                    showButtons={this.props.showButtons}
                    reservationId={this.props.reservation.olympiaLocator}
                    minPossibleDeparture={this.state.minArrivalDate}
                    departureValidationMessage='HOME.DATE_VALIDATION_ARRIVE'
                />
            </Paper>

        );

    }
}
export default translate('translations')(withStyles(styles)(ReservationFlightRender));



// WEBPACK FOOTER //
// ./src/components/Reservation/Flight/ReservationFlightRender.js